// config
// dependencies
import { List, Map } from "immutable";

import Config from "./Config";

export const getUI = (state) => state.page.get(Config.pageName, Map());
export const getGoalName = (state) => getUI(state).getIn(["goalName"], "");
export const getGoals = (state) => getUI(state).getIn(["goalsList"], List());
